import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

export const actionTypes = generateEntityCrudActionTypes('configuredUplift')
